/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Btn_Resendcodein2Inputs */

const en_btn_resendcodein2 = /** @type {(inputs: Btn_Resendcodein2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend (${i?.count})s`)
};

/**
* | output |
* | --- |
* | "Resend ({count})s" |
*
* @param {Btn_Resendcodein2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_resendcodein2 = /** @type {((inputs: Btn_Resendcodein2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Resendcodein2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_resendcodein2(inputs)
});
export { btn_resendcodein2 as "btn_resendCodeIn" }